import React, { useState } from 'react'
import { Grid } from '@material-ui/core'
import BannerRPC from './components/BannerRPC'
import BannerCampanha from './components/BannerCampanha'
import Header from './containers/Header'
import HeaderSearch from './containers/HeaderSearch'
import HeaderSearchText from './components/HeaderSearchText'
import Estabelecimentos from './containers/Estabelecimentos'

const App = (props) => {
  const [searchParams, setSearchParams] = useState({})
  const [estabelecimentosState, setEstabelecimentosState] = useState([])
  const [pagination, setPagination] = useState({
    currentPage: 0,
    pageSize: 30,
  })

  return (
    <Grid container justify='center'>
      <BannerRPC />
      {/* <BannerCampanha {...props} /> */}

      <Header {...props} />

      <Grid item xs={11} sm={10} lg={9} xl={6}>
        <HeaderSearch
          {...props}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          setEstabelecimentosState={setEstabelecimentosState}
          pagination={pagination}
          setPagination={setPagination}
        />
        <HeaderSearchText searchParams={searchParams} />
        <Estabelecimentos
          {...props}
          searchParams={searchParams}
          estabelecimentosState={estabelecimentosState}
          setEstabelecimentosState={setEstabelecimentosState}
          pagination={pagination}
          setPagination={setPagination}
        />
        <br />
        <br />
        <br />
      </Grid>
    </Grid>
  )
}

export default App
